import { useEffect } from 'react';
import { isTabKeepAliveEnabled } from '../config/tabKeepAlive';
import { useIsActivePane } from './useKeepAliveDataEffect';

/**
 * Retorna `open` apenas quando o pane keep-alive está ativo.
 * Útil para forms que preservam rascunho: o dialog some ao trocar de aba
 * sem desmontar o conteúdo interno.
 */
export const useTabScopedOpen = (open: boolean): boolean => {
  const isPaneActive = useIsActivePane();

  if (!isTabKeepAliveEnabled()) {
    return open;
  }

  return open && isPaneActive;
};

/**
 * Fecha menus/dialogs locais ao trocar de aba (pane inativo).
 * Preferível a `useTabScopedOpen` para filtros e popovers efêmeros.
 */
export const useCloseOverlayWhenPaneInactive = (
  open: boolean,
  onClose: () => void,
): void => {
  const isPaneActive = useIsActivePane();

  useEffect(() => {
    if (open && isTabKeepAliveEnabled() && !isPaneActive) {
      onClose();
    }
  }, [open, isPaneActive, onClose]);
};
